import React from "react";
import { FormGroup, Label, Col, Input } from "reactstrap";
import { updateField } from "../../../../redux/actions/configActions";
import axios from "axios";
import { connect,useSelector, useDispatch } from "react-redux";


const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
    const { configReducer } = state;
    return {
        config: configReducer.config,
        files: configReducer.files
    };
  
};
class MachineSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        mesMachines: []
    }
    this.handleEventIdChange = this.handleEventIdChange.bind(this);
}
async handleEventIdChange(event) {
  clearTimeout(this.timer);
  event.persist();
  const newId = event.target.value;
  this.props.updateField({
    machineId: newId
  });
}
  render() {
  const { config, files } = this.props;
  console.log(config);
if(this.state.mesMachines.length==0) 
{axios.get(`${process.env.REACT_APP_API_URL}machines`).then(response => {
    const data = response.data.sort((a, b) => {
      if (parseInt(a.machineId, 10) <= parseInt(b.machineId, 10)) {
        return -1;
      }
      return 1;
    });
    this.setState({mesMachines: data});
  });
}
    
  return (
    <FormGroup row>
      <Label for="setting" sm={2}>
        Machine ID
      </Label>
      <Col sm={10}>
        <Input
          required
          value={config.machineId}
          type="select"
          name="setting"
          id="setting"
          className="dropdown-black"
         onChange={this.handleEventIdChange}
        >
          <option value="" selected={!config.machineId} disabled>
            -- Select a machineId --
          </option>
          {
            this.state.mesMachines.map(index => {
              console.log(index) 
            return (<option value={index.machineId}>ID {index.machineId}</option>)
            })
          }
        </Input>
      </Col>
    </FormGroup>
  );
}
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MachineSelection);




// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/config-form-subsections/MachineSelection.jsx